<template>
    <div class="">
        <div class="form-group">
            <label>Titel des Blocks</label>
            <input type="text" class="form-control" v-model="config.title" placeholder="Sell Out">
        </div>

        <div class="form-group">
            <label>Umsatz Basis</label>
            <select class="form-control" v-model="config.base">
                <option value="listenEk">Listen EK</option>
                <option value="nettoEk">Netto EK</option>
                <option value="listenVk">Listen VK</option>
                <option value="listenVkFallback">Listen VK (Fallback)</option>
                <option value="tatsaechlicherVk">Netto VK</option>
            </select>
        </div>

        <div class="form-check my-2"
             v-if="['listenVk', 'listenVkFallback', 'tatsaechlicherVk'].includes(config.base)">
            <input class="form-check-input" type="checkbox" value="" :id="id('remove-tax')"
                   v-model="config.removeTax">
            <label class="form-check-label" :for="id('remove-tax')">
                <i class="fas fa-info-circle text-muted"
                   style=""
                   data-toggle="tooltip"
                   data-placement="top"
                   :title="$info['sellOut.removeTax']"></i>
                Mwst. herausrechnen
            </label>
        </div>

        <div class="form-group">
            <label>
                Verkaufsarten beschränken auf
            </label>
            <custom-select v-model="config.verkaufsartFilter"
                           :settings="verkaufsartSettings"
                           :options="verkaufsartOptions"/>
            <small class="text-muted">Wenn leer wird nicht gefiltert.</small>
        </div>

        <div class="form-group mb-0" v-if="selectableVisibleColumns.length">
            <label>Sichtbare Spalten:</label>
            <div class="form-check form-check-inline" v-for="column in selectableVisibleColumns">
                <input class="form-check-input"
                       type="checkbox"
                       :id="id(column.id)"
                       :value="column.id"
                       :checked="!config.hiddenColumns.includes(column.id)"
                       @change="toggleHiddenColumns(column.id, $event)">
                <label class="form-check-label" :for="id(column.id)">
                    {{ column.label }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>
import blockMixin from "./blockMixin";

export default {
    components: {},
    mixins: [blockMixin],
    props: {},
    data() {
        return {
            config: this.dto,
            verkaufsartSettings: {
                multiple: true,
                tags: false,
            }
        };
    },
    methods: {
        toggleHiddenColumns(columnId, event) {
            if (event.target.checked) {
                this.config.hiddenColumns = this.config.hiddenColumns.filter(id => id !== columnId);
            } else {
                this.config.hiddenColumns.push(columnId);
            }
        }
    },
    computed: {
        selectableVisibleColumns() {
            return [
                {id: 'absatz', label: 'Absatz'},
                {id: 'absatz-compare', label: 'Absatz Vergleich'},
                {id: 'umsatz', label: 'Umsatz'},
                {id: 'umsatz-compare', label: 'Umsatz Vergleich'},
                {id: 'absatz-anteil', label: 'Marktanalyse Absatz'},
                {id: 'umsatz-anteil', label: 'Marktanalyse Umsatz'},
            ];
        },
        verkaufsartOptions() {
            // CAUTION: WHEN CHANGING THIS, ALSO CHANGE SellOutBlockCalculator (const)
            const types = [
                'Normalverkauf',
                'Arztempfehlung/Grünes Rezept',
                'GKV ohne Zuzahlung',
                'PKV',
                'PC/Sprechstundenbedarf',
                'GKV mit Zuzahlung'
            ];

            return types.map(type => {
                return {
                    id: type,
                    text: type
                }
            });
        }
    }
}
</script>
